// extracted by mini-css-extract-plugin
module.exports = {"fixed":"Dialog_fixed__1mdmV","draggable":"Dialog_draggable__1XNH2","rnd":"Dialog_rnd__2cUQJ","dialog":"Dialog_dialog__aKVqy","backdrop":"Dialog_backdrop__34oGO"};